import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import 'brace';
import 'brace/mode/xml';
import 'brace/mode/html';


@Component({
  selector: 'app-result-dialog',
  templateUrl: './result-dialog.component.html',
  styleUrls: ['./result-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultDialogComponent implements OnInit {

  @Input() content;
  @Input() type;
  @Input() fileName;
  public xmlBase64;
  public format = require('xml-formatter');
  isXml = false;
  isPdf = false;
  isP7s = true;


  constructor() {
  }

  ngOnInit() {
    if (this.type.toLowerCase() === 'xml') {
      this.isXml = true;
      this.isPdf = false;
      this.isP7s = false;
      this.fileName = this.fileName + '.xml';
    } else if (this.type.toLowerCase() === 'pdf') {
      this.isPdf = true;
      this.isXml = false;
      this.isP7s = false;
      this.fileName = this.fileName + '.pdf';
    } else {
      this.isPdf = false;
      this.isXml = false;
      this.isP7s = true;
      this.fileName = this.fileName + '.p7s';
    }
  }

}
